import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../../services/common.service';
import {Location} from '@angular/common';
@Component({
  selector: 'app-blogmain',
  templateUrl: './blogmain.component.html',
  styleUrls: ['./blogmain.component.css']
})
export class BlogmainComponent implements OnInit {
  lifestagefilterid: any;
  breedfilterid: any;
  pettypefilterid: any;
  breed: any;
  lifestage: any;
  type: any;
  searchid: any;
  loading= false;
  blog = [];
  commentsarray= [];
  allblogs = [];
  comment: any;
  bcount = 0;
  pcount = 0;
  lcount = 0;
  found = 1;
  constructor(private doctorService: DoctorService, private route: ActivatedRoute,
    private commonService: CommonService, private router: Router, private location: Location) {
    this.route.params.subscribe(params => {
      this.type = params['type'];
      this.searchid = params['cid'];
      this.initialiseState();
    }
     );
   }

  ngOnInit() {
    this.getOurBlogs();
    this.commonService.getLifestages()
    .subscribe(
      (x) => {
        this.lifestage = x;
      }
     );
     this.doctorService.getallBreeds()
     .subscribe(
       (x) => {
         this.breed = x;
       }
      );
  }
  getOurBlogs() {
    this.loading = true;
    this.allblogs = null;
    this.doctorService.getBlogs()
    .subscribe(
      (x) => {
        this.loading = false;
        this.allblogs = x;
      }
    );
  }
  getAllBlog() {
    const searchType = localStorage.getItem('cattype');
    if ( searchType === 'breed') {
      this.loading = true;
      this.doctorService.getBlogsByBreed(this.searchid)
      .subscribe(
        (x) => {
          this.blog = x;
          this.loading = false;
          for (let i = 0; i < this.blog.length ; i++) {
            this.getCommentsOnBlog(this.blog[i].id);
          }
        }
      );
    }else if ( searchType === 'ptype') {
      this.loading = true;
      this.doctorService.getBlogsByPettype(this.searchid)
      .subscribe(
        (x) => {
          this.blog = x;
          this.loading = false;
          for (let i = 0; i < this.blog.length ; i++) {
            this.getCommentsOnBlog(this.blog[i].id);
        }
        }
      );
    }else {
      this.loading = true;
      this.doctorService.getBlogsByLifestage(this.searchid)
      .subscribe(
        (x) => {
          this.blog = x;
          this.loading = false;
          for (let i = 0; i < this.blog.length ; i++) {
            this.getCommentsOnBlog(this.blog[i].id);
        }
        }
      );
    }
  }
  getcategoryBlock() {
    this.loading = true;
    this.doctorService.getCategoryBlogs(this.searchid)
    .subscribe(
      (x) => {
        this.blog = x;
        if (this.blog && this.blog.length > 0) {
          this.found = 1;
        } else {
          this.found = 0;
        }
        this.loading = false;
        for (let i = 0; i < this.blog.length ; i++) {
          this.getCommentsOnBlog(this.blog[i].id);
      }
      }
    );
  }
  getCommentsOnBlog(bid) {
    let totalcomment;
    this.doctorService.getCommentsOnBlog(bid)
      .subscribe(
      (x) => {
        this.comment = x;
        if (this.comment && this.comment.length > 0) {
          totalcomment = this.comment.length;
          this.commentsarray['id' + bid] = totalcomment;
        }else {
          totalcomment = 0;
          this.commentsarray['id' + bid] = totalcomment;
        }
      }
      );
  }
  pettypeCount(pt) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].pet_type == pt) {
        total = total + 1;
      }
    }
    return total;
  }
  breedCount(bt) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].breed_id == bt) {
        total = total + 1;
      }
    }
    return total;
  }
  lifestageCount(lt) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].lifestage_id == lt) {
        total = total + 1;
      }
    }
    return total;
  }
  categoryCount(ct) {
    let total = 0;
    for (let i = 0; i < this.allblogs.length ; i++) {
      if (this.allblogs[i].category === ct) {
        total = total + 1;
      }
    }
    return total;
  }
  pettypeCount2(pt) {
    let total = 0;
    for (let i = 0; i < this.blog.length ; i++) {
      if (this.blog[i].pet_type === pt) {
        total = total + 1;
        this.pcount ++;
      }
    }
    return total;
  }
  breedCount2(bt) {
    
    let total = 0;
    for (let i = 0; i < this.blog.length ; i++) {
      if (this.blog[i].breed_id === bt) {
        total = total + 1;
        this.bcount ++;
      }
    }
    return total;
  }
  lifestageCount2(lt) {
    let total = 0;
    for (let i = 0; i < this.blog.length ; i++) {
      if (this.blog[i].lifestage_id === lt) {
        total = total + 1;
        this.lcount ++;
      }
    }
    return total;
  }
  setPetTypeFilter(id) {
    this.lifestagefilterid = undefined;
    this.breedfilterid = undefined;
    this.pettypefilterid = id;
  }
  setBreedFilter(id) {
    this.lifestagefilterid = undefined;
    this.pettypefilterid = undefined;
    this.breedfilterid = id;
  }
  setLifestageFilter(id) {
    this.pettypefilterid = undefined;
    this.breedfilterid = undefined;
    this.lifestagefilterid = id;
  }
  refreshmaincategory(category) {
    this.pcount = 0;
    this.lcount = 0;
    this.bcount = 0;
    this.breedfilterid = undefined;
    this.refreshPetType = undefined;
    this.lifestagefilterid = undefined;
    this.router.navigate(['/blogs/home/' + 'category',  category]);
  }
  refreshBreed(id) {
    localStorage.setItem('cattype', 'breed' );
    this.pcount = 0;
    this.lcount = 0;
    this.bcount = 0;
    this.breedfilterid = undefined;
    this.refreshPetType = undefined;
    this.lifestagefilterid = undefined;
    this.router.navigate(['/blogs/home/' + 'all',  id]);
  }
  refreshLifestage(id) {
    localStorage.setItem('cattype', 'life' );
    this.pcount = 0;
    this.lcount = 0;
    this.bcount = 0;
    this.breedfilterid = undefined;
    this.refreshPetType = undefined;
    this.lifestagefilterid = undefined;
    this.router.navigate(['/blogs/home/' + 'all',  id]);
  }
  refreshPetType(id) {
    localStorage.setItem('cattype', 'ptype' );
    this.pcount = 0;
    this.lcount = 0;
    this.bcount = 0;
    this.breedfilterid = undefined;
    this.refreshPetType = undefined;
    this.lifestagefilterid = undefined;
    this.router.navigate(['/blogs/home/' + 'all',  id]);
  }
  initialiseState() {
    if (this.type === 'all') {
      this.getAllBlog();
    }else if (this.type === 'category') {
      this.getcategoryBlock();
    }
  }
  goTodetail(id , url) {
    this.router.navigate(['/blogs/detail/' + id, url])
  }
}
